export const BASE_URL = 'https://looxis.v-shop.cloud'

export const PAYMENT_METHOD_ID = 1
